module.exports = __webpack_public_path__ + "static/media/about.a8dc0014.png";